export const environment = {
  production: true,
  airtableApiKey: 'Bearer key6XHKkJ9V1Y2Mmr',
};
